import type { ChallengeCondition } from "@/sales-tools/challenges/api/getChallenge";

export const isDisqualified = (conditions: ChallengeCondition[]) => {
    const results = conditions.map((c) => {
        if (c.threshold === "UPPER_LIMIT") {
            return c.currentValue > c.targetValue;
        }
    });

    return results.some((value) => value);
};
